export class Website {
  id?: string;
  displayName?: string;
  url?: string;
  passcode?: string;
  useTenantIdPass?: boolean;
  memo?: string;

  constructor(params?: Partial<Website>) {
    Object.assign(this, params);
  }
}
